import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { AdminService } from 'app/_services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UserStatus } from 'app/_models/user-status';
import { States } from 'app/_models/states';
import { AppRoles } from 'app/_models/roles'
import { Cities } from 'app/_models/cities';
import { RegisterUserModel } from 'app/_models/user-model';
import { StateService } from 'app/_services/state.service';
declare const swal: any;

export function customEmailValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.value;
  const emailPattern = /^[a-z0-9._%+-]+@tsiplc\.com$/;

  if (!email) return null;

  if (email.length > 150) {
    return { invalidEmail: 'Email must be 150 characters or fewer.' };
  }

  if (!emailPattern.test(email)) {
    return { invalidEmail: 'Please enter a valid lowercase @tsiplc.com email address.' };
  }

  return null;
}

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  isLoaderResult: boolean = false;
  addUserForm: UntypedFormGroup;
  //model: FormArray;
  states: States[] = [];
  cities: Cities[] = [];
  roles: AppRoles[] = [];
  userStatus: UserStatus[] = [];
  registerUserModel: RegisterUserModel;
  panelOpenState = false;
  searchText: string;
  selectedStates: States[];  

  constructor(
    private readonly toastr: ToastrService,
    private readonly adminService: AdminService,
    private readonly router: Router,
    private  readonly stateService: StateService,
    private readonly formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.addUserForm = new UntypedFormGroup({
      model: new UntypedFormArray([])
    });

    this.addItem();

    this.getRoles();
    this.getUserStatus();
    this.addUserForm.valueChanges.subscribe(value => { 
     // console.log(value) 
    });
    this.stateService.getStates().subscribe(states => {
      this.states = states;
      this.selectedStates = states;
    })
  }

  createUserForm(): UntypedFormGroup {
    return this.formBuilder.group({
      firstName: [null, [Validators.required,  Validators.pattern('^(?![ .]+$)([a-zA-Z]+[ .]*)*$'), Validators.maxLength(20)]],
      lastName: [null, [Validators.required,  Validators.pattern('^(?![ .]+$)([a-zA-Z]+[ .]*)*$'), Validators.maxLength(20)]],
      employeeId: [null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]+$') , // Alphanumeric only, no special characters
        Validators.maxLength(20)
      ]],
      phoneNumber: [null, [
        Validators.required,
        Validators.pattern('^[0-9]{10}$')  // Exactly 10 digits, only numbers
      ]],
      email: [null, [
        Validators.required,
        customEmailValidator 
      ]],
      stateId: [null, [Validators.required]],
      cityId: [null, [Validators.required]],
      appStatusId: [null, [Validators.required]],
      roleId: [null, [Validators.required]]
    });
  }

  deleteGroup(index: number) {
    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Remove IT!'
    }).then((result) => {
      if (result === true) {
        const formArray = this.addUserForm.get('model') as UntypedFormArray;
        formArray.removeAt(index);
      }
      else {
        this.toastr.info('result not saved')
      }
    })

  }
 
  
  addItem(): void {
    const formArray = this.addUserForm.get('model') as UntypedFormArray;
    formArray.push(this.createUserForm());
  }

  onSelectionchange(e) {
    this.stateService.getCityByStateId(e.value).subscribe(
      state => {
        this.cities = state.cities;
      }) ;
  }

  saveUser() {
    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Add IT!'
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        this.addUser()
      }
      else {
        this.toastr.info('result not saved')
      }
    })
  }

  getUserStatus() {
    this.adminService.getUserStatus().subscribe(result => {
      this.userStatus = result;
    })
  }

  getRoles() {
    this.adminService.getRoles().subscribe(result => {
      this.roles = result.filter((role: AppRoles) => role.roleName !== 'SystemAdmin');
    })
  }

  addUser() {
    this.adminService.addBulkUsers(this.addUserForm.value).subscribe(data => {
      if(data.didError) 
      {
        swal({
          title: '',
          text: data.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info'
        });
        this.isLoaderResult = false;
      } 
      else{
        swal({
          title: '',
          text: data.message,
          type: 'success',
          confirmButtonClass: 'btn btn-info'
        });
        this.isLoaderResult = false;
        this.router.navigateByUrl('user-management');
      }
       
     
    }, error => {
      this.toastr.error('Error in adding user' + error.error);
      this.isLoaderResult = false;
    })   
  }

  goBack() {
    swal({
      title: 'Are you sure?',
      text: 'All form data will be lost!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES!'
    }).then((result) => {
      
      if (result === true) {
        this.router.navigateByUrl('user-management');
      }
      else {
        this.toastr.info('result not saved')
      }
    })
  }
  
 search(value: string) {
  const filter = value?.toLowerCase() ?? '';
  this.selectedStates = [];

  for (const state of this.states) {
    if (state.stateName.toLowerCase().includes(filter)) {
      this.selectedStates.push(state);
    }
  }

  return this.selectedStates;
}

}
